
import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Send } from "lucide-react";
import { useToast } from "@/hooks/use-toast";
import { supabase } from "@/integrations/supabase/client";

export const TestMessage = () => {
  const { toast } = useToast();
  const [isTesting, setIsTesting] = useState(false);

  const sendTestMessage = async () => {
    try {
      setIsTesting(true);
      
      const { data: { user } } = await supabase.auth.getUser();
      if (!user) {
        throw new Error('User not found');
      }

      // Get the user's API key
      const { data: apiKeys, error: apiKeyError } = await supabase
        .from('api_keys')
        .select('api_key')
        .eq('user_id', user.id)
        .eq('is_active', true)
        .limit(1);

      if (apiKeyError || !apiKeys || apiKeys.length === 0) {
        throw new Error('Please generate an API key in your API settings first');
      }

      const apiKey = apiKeys[0].api_key;

      // Get the user's phone number
      const { data: settings, error: settingsError } = await supabase
        .from('user_settings')
        .select('phone_number')
        .eq('user_id', user.id)
        .single();

      if (settingsError || !settings?.phone_number) {
        throw new Error('Please add your phone number in settings first');
      }

      // Call our new httpsms-handler edge function
      const { error } = await supabase.functions.invoke('httpsms-handler', {
        body: { 
          to: settings.phone_number,
          content: "This is a test message from httpSMS integration"
        },
        headers: {
          'x-api-key': apiKey
        }
      });

      if (error) throw error;

      toast({
        title: "Test message sent!",
        description: "Check your phone for the test message.",
      });
    } catch (error: any) {
      console.error('Error sending test message:', error);
      toast({
        title: "Error",
        description: error.message,
        variant: "destructive",
      });
    } finally {
      setIsTesting(false);
    }
  };

  return (
    <Button
      variant="outline"
      className="ml-2 bg-green-500 text-white hover:bg-green-600 border-none"
      onClick={sendTestMessage}
      disabled={isTesting}
    >
      {isTesting ? "Sending..." : "Send Test Message"} <Send className="ml-2 h-4 w-4" />
    </Button>
  );
};
